import React from "react";
import { Input } from "@windmill/react-ui";

const InputAreaToll = ({
  register,
  trigger,
  defaultValue,
  required,
  name,
  label,
  type,
  placeholder,
  pattern,
  minLength,
  maxLength,
  value,
  readOnly,
  onChange,
  capitalize,
  min,
  max,
}) => {
  const validation = {
    required: required === false ? false : `${label} is required!`,
    pattern: {
      value: pattern,
      message: `Invalid ${label}!`,
    },
    maxLength: {
      value: maxLength,
      message: `Maximum Length ${maxLength} !`,
    },
    minLength: {
      value: minLength,
      message: `Minimum Length ${minLength} !`,
    },
    validate: (value) => {
      if (
        typeof value === "string" &&
        value.trim() === "" &&
        required !== false
      ) {
        return `${label} is required!`;
      }
      if (type === "number") {
        const numericValue = Number(value);

        // Allow 0, but reject negatives and non-numbers
        if (isNaN(numericValue) || numericValue < 0) {
          return `${label} must be 0 or greater!`;
        }

        if (max !== undefined && numericValue > max) {
          return `${label} cannot exceed ${max}!`;
        }

        if (min !== undefined && numericValue < min) {
          return `${label} cannot be less than ${min}!`;
        }
      }
      return true;
    },
  };
  const handleInput = (event) => {
    let inputValue = event.target.value;

    if (capitalize) {
      inputValue = inputValue.toUpperCase();
    }
    event.target.value = inputValue;
    if (inputValue.length > maxLength) {
      event.target.value = inputValue.slice(0, maxLength);
      return;
    }
  };

  return (
    <>
      <Input
        {...register(`${name}`, validation)}
        defaultValue={defaultValue}
        type={type}
        placeholder={placeholder}
        onInput={handleInput}
        name={name}
        // onBlur={() => trigger(`${name}`)}
        value={value}
        readOnly={readOnly}
        onChange={onChange}
        autoComplete="off"
        className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      />
    </>
  );
};

export default InputAreaToll;
